import { IBasicNode } from '@interfaces/components/tree';

import { FLAT_NODE_PATH_SEPARATOR } from '@constants/common';

export const isChildNode = (node: IBasicNode, baseNodePath: string) => {
	return node.path.startsWith(baseNodePath + FLAT_NODE_PATH_SEPARATOR);
};

export const isSamePath = (node: IBasicNode, baseNodePath: string) => {
	return node.path === baseNodePath;
};

export const isCommonNodeRoot = (node: IBasicNode, baseNodePath: string) => {
	return isChildNode(node, baseNodePath) || isSamePath(node, baseNodePath);
};
